import { render, staticRenderFns } from "./OrderManagementList.vue?vue&type=template&id=4237ea66"
import script from "./OrderManagementList.vue?vue&type=script&lang=ts"
export * from "./OrderManagementList.vue?vue&type=script&lang=ts"
import style0 from "./OrderManagementList.vue?vue&type=style&index=0&id=4237ea66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports